import { loadScript } from './index'

export default defineNuxtPlugin(() => {
  loadScript()
})
